import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import {Medicion} from './medicion';

import myGlobals = require('../config');

var moment = require('moment');

@Injectable()
export class MedicionService {

    private medicionUrl = myGlobals.default.BASE_URL + '/medicion/';  // URL to web api

    constructor(private http: Http) {
    }

    //Obtener todas las mediciones
    getMediciones() {
        return this.http.get(this.medicionUrl)
            .map((response) => response.json());
    }

    //Obtener mediciones por sensor
    getMedicionesBySensor(_id: string): Observable<Medicion[]> {
        return this.http.get(this.medicionUrl + _id + "/20")
            .map((response) => response.json());
    }

    //Obtener mediciones por sensor
    getAllMedicionesBySensor(_id: string): Observable<Medicion[]> {
        return this.http.get(this.medicionUrl + _id + "/all")
            .map((response) => response.json());
    }

    //Obtener mediciones por sensor
    getAllMedicionesBySensorYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<Medicion[]> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.medicionUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => response.json());
    }

    //Obtener media por sensor
    getPromedioMedicionesBySensorYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<any> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.medicionUrl + "promedio/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => response.json());
    }

    //Obtener mkt por sensor
    getMKTMedicionesBySensorYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<any> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.medicionUrl + "mkt/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => response.json());
    }

    //Obtener minimo y maximo por sensor
    getMinMaxMedicionesBySensorYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<any> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.medicionUrl + "minmax/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => response.json());
    }

    //Obtener mediciones por sensor
    getAllMedicionesBySucursalYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<any> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();

        return this.http.get(this.medicionUrl + "export/sucursal/" + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => {
                const linkSource = `data:application/zip;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "reporteMedicionesBemakoha-" + fechaDesdeStr.split('T')[0] + '-' + fechaHastaStr.split('T')[0] + ".zip";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/medicion/medicion.service.ts